import { format, getMonth, getYear } from 'date-fns'
import type { Locale } from 'date-fns'

const RANGE_SEPARATOR = '–'

/**
 * Formats a custom date range for a `PeriodPicker` trigger, e.g. "1–5 Feb 2026", "28 Feb–5 Mar 2026" or
 * "20 Dec 2025–3 Jan 2026" depending on whether the two dates share a month and/or year.
 */
export const formatCustomRangeTriggerLabel = (
  start: Date | null,
  end: Date | null,
  locale: Locale,
): string | undefined => {
  if (!start || !end) {
    return undefined
  }

  const sameYear = getYear(start) === getYear(end)
  const sameMonth = sameYear && getMonth(start) === getMonth(end)

  if (sameMonth) {
    return `${format(start, 'd', { locale })}${RANGE_SEPARATOR}${format(end, 'd MMM yyyy', { locale })}`
  }

  if (sameYear) {
    return `${format(start, 'd MMM', { locale })}${RANGE_SEPARATOR}${format(end, 'd MMM yyyy', { locale })}`
  }

  return `${format(start, 'd MMM yyyy', { locale })}${RANGE_SEPARATOR}${format(end, 'd MMM yyyy', { locale })}`
}
